import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PersonalInformationPage = lazy(() => import("./PersonalInformationPage"));

const PersonalInformationPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PersonalInformationPage />
    </Suspense>
  );
};

export default PersonalInformationPageLazy;
